import moment from 'moment/moment';

import {
  EmployeeCollaborationTask,
  EmployeeCollaborationTaskList,
  EmployeeCollaborationWorklistStatus,
} from '~/data/collaboration';
import { convertToDateOrUndefined } from '~/utils/helper';

export type WorklistFormData = {
  worklistId: string;
  isLocked: boolean;
  status: EmployeeCollaborationWorklistStatus;
  templateId: number;
  startDate?: Date;
  dueDate?: Date;
  employeeId: number;
  language?: string;
  tasks: EmployeeCollaborationTask[];
};

export const convertWorklistToEditWorklistData = (
  worklist: EmployeeCollaborationTaskList,
): WorklistFormData => {
  const {
    fEmpWorklistUid,
    fEmpWorklistIsLocked,
    fEmpWorklistStatus,
    fEmpWorklistTemplateId,
    fEmpWorklistStartDate,
    fEmpWorklistDueDate,
    fEmpWorklistEmployeeId,
    fEmpWorklistLanguage,
    fEmpWorklistTasks,
  } = worklist;

  return {
    worklistId: fEmpWorklistUid,
    isLocked: fEmpWorklistIsLocked,
    status: fEmpWorklistStatus,
    templateId: fEmpWorklistTemplateId,
    startDate: convertToDateOrUndefined(fEmpWorklistStartDate),
    dueDate: convertToDateOrUndefined(fEmpWorklistDueDate),
    employeeId: fEmpWorklistEmployeeId,
    language: fEmpWorklistLanguage,
    tasks: fEmpWorklistTasks,
  };
};

export const convertEditWorklistDataToSubmitPayload = (
  data: WorklistFormData,
  overrideTasks?: EmployeeCollaborationTaskList['fEmpWorklistTasks'],
): EmployeeCollaborationTaskList => {
  const {
    worklistId,
    isLocked,
    status,
    templateId,
    startDate,
    dueDate,
    employeeId,
    language,
    tasks,
  } = data;

  const formatDate = (date?: Date): string => {
    return !!date ? moment(date).format('YYYY-MM-DD') : '';
  };

  return {
    fEmpWorklistUid: worklistId,
    fEmpWorklistIsLocked: isLocked,
    fEmpWorklistStatus: status,
    fEmpWorklistEmployeeId: employeeId,
    fEmpWorklistStartDate: formatDate(startDate),
    fEmpWorklistDueDate: formatDate(dueDate),
    fEmpWorklistTemplateId: templateId,
    fEmpWorklistLanguage: language,
    fEmpWorklistTasks: !!overrideTasks ? overrideTasks : tasks,
  };
};
